import { getItem } from "../safe-storage.js";

// Same Cloud Run URL as zep/apps-app
const APP_LAUNCH_URL = "https://applaunch-rqfgqadjxa-ez.a.run.app";

// Must match Firebase secret ZEP_APP_SECRET
const W2L_APP_SECRET = "yOL7/Xl3FsIHGYihibY+thG0MlTeezrqx3pONsvCODQ=";

function readStored(key) {
  return getItem(key) || "";
}

/** Identity the home screen already carries from Zep / prior visits. */
export function getHomeIdentity() {
  const params = new URLSearchParams(window.location.search);
  return {
    userId: params.get("userId") || readStored("w2l_uid") || "",
    nickname: params.get("nickname") || readStored("w2l_nickname") || "",
    spaceId: params.get("spaceId") || readStored("w2l_space_id") || "",
    mapId: params.get("mapId") || readStored("w2l_map_id") || "",
    room: params.get("room") || "",
  };
}

/**
 * Request an OIDC session redirect URL from appLaunch (same handoff as Zep).
 * @param {{ app: string, room?: string }} options
 * @return {Promise<string>}
 */
export async function requestOidcLaunchUrl({ app, room = "" }) {
  const { userId, nickname, spaceId, room: roomFromUrl } = getHomeIdentity();
  const resolvedRoom = room || roomFromUrl;

  if (!userId || !spaceId) {
    throw new Error("missing_identity");
  }

  const body = {
    app,
    userId,
    spaceId,
    nickname,
    format: "json",
  };
  if (resolvedRoom && app === "nodecast") {
    body.room = resolvedRoom;
  }

  const response = await fetch(APP_LAUNCH_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-W2L-Secret": W2L_APP_SECRET,
    },
    body: JSON.stringify(body),
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch {
    payload = {};
  }

  if (!response.ok || !payload.success || !payload.url) {
    const message =
      (payload && (payload.message || payload.error)) ||
      `launch_failed_${response.status}`;
    throw new Error(message);
  }

  return payload.url;
}
